import { render, staticRenderFns } from "./testCate.vue?vue&type=template&id=f8ef8aa0&scoped=true&"
import script from "./testCate.vue?vue&type=script&lang=js&"
export * from "./testCate.vue?vue&type=script&lang=js&"
import style0 from "./testCate.vue?vue&type=style&index=0&id=f8ef8aa0&prod&lang=scss&scoped=true&"
import style1 from "./testCate.vue?vue&type=style&index=1&id=f8ef8aa0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ef8aa0",
  null
  
)

export default component.exports